import _ from 'lodash';
import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLoanOptionConfiguration = createSelector(
  selectLoanApplication,
  ({ loanOption }) => loanOption,
);

export const selectOBFilterOptions = createSelector(
  selectLoanOptionConfiguration,
  ({ searchFilterSchema = {} }) => {
    return {
      loanType: _.map(searchFilterSchema.loanType, i => ({
        label: i.displayText,
        value: i.value,
        isSelected: i.isSelected,
      })),
      amortizationTypes: _.map(searchFilterSchema.amortizationTypes, i => ({
        label: i.displayText,
        value: i.value,
        isSelected: i.isSelected,
      })),
      loanTerm: _.map(searchFilterSchema.loanTerm, i => ({
        label: i.displayText,
        value: i.value,
        isSelected: i.isSelected,
      })),
      lockTerm: _.map(searchFilterSchema.lockTerm, i => ({
        label: i.displayText,
        value: i.value,
        isSelected: i.isSelected,
      })),
      investorIds: _.map(searchFilterSchema.investor, i => ({
        label: i.displayText,
        value: i.value,
        isSelected: i.isSelected,
      })),
    };
  },
);
